/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.UserChirpService
 */
import * as References from './UserChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.UserChirpService#searchUsersOnPortal
 */
export const SEARCH_USERS_ON_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_UserChirpService_searchUsersOnPortal';
export const SEARCH_USERS_ON_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_USERS_ON_PORTAL_QUERY_FIELD_NAME,
  args: ['targetPortalId', 'query', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchUsersOnPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});